// CMS-Service für Alben (EE-Releases) — Admin-Endpoints /api/admin/albums.
// Auth-Muster identisch zu playlistService (eigene axios-Instanz + Bearer aus der Supabase-Session).
import axios, { AxiosInstance } from 'axios';
import { getApiBaseUrl } from '../utils/apiConfig';
import { getAccessToken } from '../lib/authToken';
import { Album, CreateAlbumInput, UpdateAlbumInput } from '../types/album';

class AlbumService {
  private api: AxiosInstance;

  constructor() {
    this.api = axios.create({
      baseURL: getApiBaseUrl(),
      timeout: 15000,
      headers: { 'Content-Type': 'application/json' },
    });
    this.api.interceptors.request.use(async (config) => {
      const token = await getAccessToken();
      if (token) config.headers.Authorization = `Bearer ${token}`;
      return config;
    });
  }

  async getAlbums(): Promise<Album[]> {
    const res = await this.api.get<{ data: Album[] }>('/api/admin/albums');
    return res.data.data ?? [];
  }

  async getAlbumById(id: string): Promise<Album> {
    const res = await this.api.get<{ data: Album }>(`/api/admin/albums/${id}`);
    return res.data.data;
  }

  async createAlbum(input: CreateAlbumInput): Promise<Album> {
    const res = await this.api.post<{ data: Album }>('/api/admin/albums', input);
    return res.data.data;
  }

  async updateAlbum(id: string, input: UpdateAlbumInput): Promise<Album> {
    const res = await this.api.patch<{ data: Album }>(`/api/admin/albums/${id}`, input);
    return res.data.data;
  }

  async deleteAlbum(id: string): Promise<void> {
    await this.api.delete(`/api/admin/albums/${id}`);
  }

  // Produkte (contentIds) + Reihenfolge eines Albums setzen (ganze Liste, ein Call).
  async setContent(albumId: string, contentIds: string[]): Promise<Album> {
    const res = await this.api.put<{ data: Album }>(
      `/api/admin/albums/${albumId}/content`,
      { contentIds }
    );
    return res.data.data;
  }
}

export const albumService = new AlbumService();
